import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Visa = () => {
  return (
    <React.Fragment>
      <SEO title="Visa | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Visa"
        content="For Participants"
        contentTwo="Visa"
        // linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <div className="visa">
            <h3>
              A Brief Introduction to Chinese Visa and the Procedure for Visa
              Application
            </h3>
            <div align="justify">
              Chinese visa is a permit issued to a foreigner by the Chinese visa
              authorities for entry into, exit from or transit through the
              Chinese territory. The Chinese visa authorities may issue a
              diplomatic, courtesy, service or ordinary visa to a foreigner
              according to his identity, purpose of visit to China and passport
              type. Hereunder is an introduction to the ordinary visa and its
              application procedure:
            </div>
            <p align="justify">
              The ordinary visas consist of eight sub-categories, which are
              marked with Chinese phonetic letters (D, Z, X, F, L, G, C, J-1 and
              J-2 respectively).
            </p>
            <p align="justify">
              <b>Visa D</b>: issued to aliens who are to reside permanently in
              China. A permanent residence confirmation form shall be required
              for the application of Visa D. The applicant shall apply to obtain
              this form himself or through his designated relatives in China
              from the exit-and-entry department of the public security bureau
              in the city or county where he applies to reside.
            </p>
            <p align="justify">
              <b>Visa Z</b>: Issued to aliens who are to take up posts or
              employment in China, and to their accompanying family members. To
              apply for a Visa Z, an Employment License of the People’s Republic
              of China for Foreigners (which could be obtained by the employer
              in China from the provincial or municipal labor authorities) and a
              visa notification letter/telegram issued by an authorized
              organization or company are required.
            </p>
            <p align="justify">
              <b>Visa X</b>: Issued to aliens who come to China for study,
              advanced studies or job-training for a period of six months or
              more. To apply for a Visa X, certificates from the receiving unit
              and the competent authority concerned are required, i.e.,
              Application Form for Overseas Students to China (JW201 Form or
              JW202 Form), Admission Notice and Physical Examination Record for
              Foreigners.
            </p>
            <p align="justify">
              <b>Visa F</b>: Issued to an applicant who is invited to China on a
              visit, on a study or lecture, business tour, for
              scientific-technological and cultural exchanges, for short-term
              refresher course or for job-training, for a period of no more than
              six months. To apply for a Visa F, the invitation letter from the
              inviting unit or the visa notification letter/telegram from the
              authorized unit is required.
            </p>
            <p align="justify">
              <b>Visa L</b>: Issued to aliens who come to China for sightseeing,
              visiting relatives or other private purposes. For a tourist
              applicant, in principle he shall evidence his financial capability
              of covering the travelling expenses in China, and when necessary,
              provide the air, train or ship tickets to the heading
              country/region after leaving China. For the applicants who come to
              China to visit relatives, some are required to provide invitation
              letters from their relatives in China.
            </p>
            <p align="justify">
              <b>Visa G</b>: Issued to aliens who transit through China. The
              applicants are required to show valid visas and on-going tickets
              to the heading countries/regions.
            </p>
            <p align="justify">
              <b>Visa C</b>: Issued to train attendants, air crewmembers and
              seamen operating international services, and to their accompanying
              family members. To apply for a visa C, relevant documents are
              required to be provided in accordance with bilateral agreements or
              regulations of the Chinese side.
            </p>
            <p align="justify">
              <b>Visa J-1</b>: Issued to foreign resident correspondents in
              China.
            </p>
            <p align="justify">
              <b>Visa J-2</b>: Issued to foreign correspondents who make short
              trip to China on reporting tasks.
            </p>
            <p align="justify">
              The applicants for J-1 and J-2 visas are required to provide a
              certificate issued by the competent Chinese authorities.
            </p>
            <p align="justify">
              In addition to providing the above-mentioned documents, an
              applicant is also required to answer relevant questions and go
              through the following formalities (with the exception of those
              stipulated otherwise by agreements):Providing valid passport or a
              travel document in lieu of the passport Filling out a visa
              application form, and providing a recent 2-inch, bareheaded and
              full-faced passport photo.
            </p>
            <p align="justify">
              The overseas Chinese visa authorities are Chinese embassies,
              consulates, visa offices, the consular department of the Office of
              the Commissioner of the Ministry of Foreign Affairs in HKSAR, and
              other agencies abroad authorized by the Ministry of Foreign
              Affairs of China. If a foreigner intends to enter into, exit from
              or transit through the Chinese territory, he shall apply to the
              above-mentioned Chinese visa authorities for a Chinese visa.
            </p>
            <p align="justify">
              For further information, please consult the nearest Chinese visa
              authorities.
            </p>
            <p align="justify">
              The above message is quoted from{" "}
              <a href="http://www.fmprc.gov.cn/eng/default.htm">
                Ministry of Foreign Affairs , the People’s Republic of China
              </a>
              .
            </p>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Visa;
